import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import {CUSTOM_METRIC_NAME_MAX_LENGTH} from '../../lib/measurement-constants';

export type CustomMetricNameFormValues = {
  readonly name: string;
};

export class CustomMetricNameValidator implements Validator<CustomMetricNameFormValues> {
  readonly standardSchema = z.object({
    name: z
      .string()
      .trim()
      .min(1, 'Name is required.')
      .max(
        CUSTOM_METRIC_NAME_MAX_LENGTH,
        `Name must be at most ${CUSTOM_METRIC_NAME_MAX_LENGTH} characters.`,
      ),
  });

  validate(value: unknown): Result<CustomMetricNameFormValues, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid metric name.'));
    }
    return ok(parsed.data);
  }
}
